var React = require('react');

function SortIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M14.0003 10.668L11.3337 13.3346L8.66699 10.668","stroke":"black","strokeWidth":"1.33333","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M11.333 13.3346V2.66797","stroke":"black","strokeWidth":"1.33333","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M2 5.33464L4.66667 2.66797L7.33333 5.33464","stroke":"black","strokeWidth":"1.33333","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M4.66699 2.66797V13.3346","stroke":"black","strokeWidth":"1.33333","strokeLinecap":"round","strokeLinejoin":"round","key":3})]);
}

SortIcon.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = SortIcon;

SortIcon.default = SortIcon;
